interface ShareModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onCopy: () => void;
  onSocial: (platform: string) => void;
}

const platforms = [
  { key: 'wechat', label: '微信', icon: 'ri-wechat-2-line' },
  { key: 'moments', label: '朋友圈', icon: 'ri-wechat-fill' },
  { key: 'weibo', label: '微博', icon: 'ri-weibo-line' },
  { key: 'qq', label: 'QQ', icon: 'ri-qq-line' },
];

export default function ShareModal({ open, title, onClose, onCopy, onSocial }: ShareModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
    >
      <button
        type="button"
        aria-label="关闭分享"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/40 cursor-pointer"
      ></button>
      <div className="relative w-full max-w-md rounded-lg bg-background-50 p-6 animate-fade-up">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">分享这篇内容</h3>
            <p className="mt-1 text-sm text-foreground-500 line-clamp-2">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="shrink-0 w-8 h-8 flex items-center justify-center rounded-md text-foreground-400 hover:bg-background-100 transition-colors"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {platforms.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => onSocial(item.key)}
              className="flex flex-col items-center gap-2 rounded-md py-3 text-foreground-600 hover:bg-background-100 transition-colors"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-50 text-primary-600">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-xs">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="mt-6 flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2">
          <i className="ri-link text-foreground-400"></i>
          <span className="flex-1 truncate text-sm text-foreground-500">复制页面链接分享给好友</span>
          <button
            type="button"
            onClick={onCopy}
            className="shrink-0 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            复制链接
          </button>
        </div>
      </div>
    </div>
  );
}